import { CohortConfig } from "./CohortConfig";
import { DurationSelector } from "./DurationSelector";
import { FieldPickerV1 } from "./FieldPicker";

export const PlatformCypressConstants = {
  DurationSelector,
  CohortConfig,
  FieldPickerV1
};
